import React from "react";
import "./Setting.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/actions/authActions";
import { getProjects } from "../../Redux/actions/projectsActions";
import { Profile_show } from "../../assets/icons";

export default function Setting({ isSettingOpen, setIsSettingOpen }) {
  // console.log('Project Navbar_1 Setting popup ');

  const location = useLocation();
  // console.log('Setting location = ',location);
  const project = useSelector((state) => state?.project);
  // console.log('Setting Popup Redux Store Data = ',project);
  
  const { _id , isCard} = useSelector((state) => state?.project);

  const {isDashboard, isMoreInfo} = location?.state || {};
  // console.log(' Navbar_1 Setting popup isCard = ',isCard);  
  
  const pathSegments = location.pathname.split("/");
  //  console.log('pathSegments = ',pathSegments, pathSegments.length);
  const pathname = pathSegments[1];
  // console.log('More Info Setting Profile pathname=> ',pathname)
  const projectId = pathSegments[3];

  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pageSelect = useSelector((state) => state?.commonReducer?.selectedPageOption);
  // console.log('pageSelect=>',pageSelect);

  const commonReducer = useSelector((state) => state?.commonReducer);
  const currentPlan = commonReducer?.currentPlan;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${
        createdAt?.getMonth() + 1
      }/${createdAt?.getFullYear()}`;

  const logoutHandler = () => {
    dispatch(logout(() => navigate("/")));
    dispatch(getProjects("logout"));
  };

  const getUserInitials = () => {
    // console.log("userInfo:", userInfo); // Debugging output
  
    const firstName = userInfo?.firstName?.trim() || "";
    // const lastName = userInfo?.lastName?.trim() || "";
  
    if (firstName) {
      return `${firstName.charAt(0).toUpperCase()}`;
    }
    return "U"; // Default initial if no name is available
  };

  const getBackgroundColor = () => {
    const initials = getUserInitials(); // Get initials
    const firstLetter = initials.charAt(0); // Extract first letter
    const colors = {
      A: "#413CAA", B: "#413CAA", C: "#413CAA", D: "#413CAA", E: "#413CAA",
      F: "#413CAA", G: "#413CAA", H: "#413CAA", I: "#413CAA", J: "#413CAA",
      K: "#413CAA", L: "#413CAA", M: "#413CAA", N: "#413CAA", O: "#413CAA",
      P: "#413CAA", Q: "#413CAA", R: "#413CAA", S: "#413CAA", T: "#413CAA",
      U: "#413CAA", V: "#413CAA", W: "#413CAA", X: "#413CAA", Y: "#413CAA",
      Z: "#413CAA"
    };
    return colors[firstLetter] || "#413CAA"; // Default color if not found
  };

  const navigateToBillingInfo = () => {

    // From Dashboard Navbar Setting User Profile
    if((pathname==='dashboard' && pathSegments.length === 2 ) ||(isDashboard && isMoreInfo)) { 
      navigate("/more_info", { state: {isDashboard: true} });
    }
    
    // From Project Navbar Setting User Profile If Card Selected
    else if(!isDashboard){ 
      navigate("/more_info", { state: {isDashboard: isDashboard, isMoreInfo:true, projectId: _id, isCard: isCard? isCard: false,} });
    }




  } 

  return (
    <>
      {isSettingOpen === true && (

        <div className={`cstmmodal`}>
          <div className="cstmmodal-overlay" onClick={() => setIsSettingOpen(false)}></div>

          <div className="cstmmodal-content2">
            <div className="flex flex-col justify-evenly items-center">
              {/* <span className="close-button" onClick={() => setIsSettingOpen(false)}>&#10005;</span> */}

              <div className="w-[70px] h-[70px] rounded-full flex justify-center items-center manrope-600 text-[40px] text-white my-3 FirstLastTaG"
                style={{backgroundColor: getBackgroundColor()}}
              >
                <span>{getUserInitials()}</span>
              </div>

              <div className="user-details my-1">
                <p className="capitalize manrope-600 text-base">Hi{" "}{userInfo?.firstName} {userInfo?.lastName}!</p>
                <p className="pb-3 manrope-400 pt-[2px] text-xs">{userInfo?.email}</p>
              </div>

              <div className="logout_divv mb-1">
                <button className="logout_btn text-sm manrope-800" onClick={logoutHandler}>Logout</button>
              </div>

              <div className="w-full border border-[#282831] my-3.5 mx-auto opacity-25"></div>

              {/* <div className="other_sub_div text-center">
                <div className="">
                  <p className="mt-[0px]">Current Plan -{" "}{currentPlanDetails?._id ? currentPlanDetails?.type : "Free"}</p>

                  <p className="mt-[10px]">Validity -{" "}{currentPlanDetails?._id ? currentPlanDetails?.validity : ""}</p>

                  <p className="mt-[10px]">Purchase Date - {planPurchaseDate}</p>

                  <button className="plan-btn Syne700" onClick={() => navigate("/dashboard/pricingPlans")}>Upgrade</button>
                </div>
              </div> */}

              {/* <div className="other_sub_div "><button  onClick={() => navigate("/user-plans")}>Upgrade</button></div>                */}
              {/* <div className="w-full border border-[#696978] my-3.5 mx-auto opacity-25"></div> */}

              <div className="">
                <div className="other_sub_div"><Link to="/account-settings">My Account</Link></div>
                <div className="other_sub_div ">
                  <button disabled={pathname==='more_info' ? true : false} onClick={navigateToBillingInfo}>Billing Info</button>
                </div>

                <div className="other_sub_div ">
                  <button onClick={() => window.open(`/help`)}>Help Desk</button>
                </div>

                <div className="other_sub_div mb-4">
                  <a rel="noopener noreferrer" href={"https://scrollx.io/contact/"} target="_blank">Contact us</a>
                </div>

              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
}
